import { render } from "./RelationGraphView.vue?vue&type=template&id=76497100&scoped=true"
import script from "./RelationGraphView.vue?vue&type=script&lang=js"
export * from "./RelationGraphView.vue?vue&type=script&lang=js"

import "./RelationGraphView.vue?vue&type=style&index=0&id=76497100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76497100"]])

export default __exports__